import * as React from "react";

const SettingIcon = ({
  height = "16px",
  width = "16px",
  color = "#000000",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    height={height}
    width={width}
    viewBox="0 0 485 485"
    xmlSpace="preserve"
    {...props}
  >
    <g>
      <path d="M485,287.5v-100h-66.946c-3.975-14.006-9.602-27.421-16.818-40.096l44.558-44.558l-70.711-70.711l-45.141,45.142   c-13.425-7.352-27.628-12.935-42.441-16.684V0h-100v63.446c-14.552,4.584-28.394,10.959-41.364,19.05l-43.29-43.29l-70.711,70.711   l46.716,46.716c-6.452,13.021-11.287,26.694-14.45,40.866H0v100h70.103c4.426,12.733,10.245,24.898,17.394,36.363l-48.291,48.291   l70.711,70.711l51.717-51.717c11.471,5.682,23.468,10.116,35.865,13.257V485h100v-73.449c12.211-3.851,23.95-8.975,35.095-15.317   l49.559,49.56l70.711-70.711l-50.143-50.143c6.506-11.89,11.635-24.416,15.332-37.439H485z M410.438,375.083l-28.285,28.284   l-45.379-45.38l-10.22,6.766c-14.623,9.681-30.646,16.698-47.624,20.859l-11.43,2.801V455h-40v-65.214l-12.331-2.23   c-17.205-3.111-33.615-9.125-48.775-17.875l-9.967-5.752l-46.509,46.509l-28.284-28.284l44.859-44.859l-7.517-10.362   c-10.678-14.721-18.552-31.023-23.401-48.453L92.519,267.5H30v-40h59.781l1.913-12.78c2.822-18.861,9.089-36.803,18.625-53.326   l5.752-9.967l-41.509-41.509l28.284-28.284l39.859,39.859l10.362-7.517c16.024-11.624,33.856-19.896,53.002-24.587l11.43-2.801V30   h40v55.214l12.331,2.23c19.427,3.513,37.743,10.684,54.44,21.314l10.152,6.463l40.659-40.659l28.284,28.284l-40.379,40.38   l6.765,10.22c10.565,15.96,17.935,33.514,21.902,52.174l2.526,11.88H455v40h-60.82l-2.525,11.881   c-3.775,17.758-10.643,34.544-20.413,49.891l-6.462,10.152L410.438,375.083z" />
      <path d="M242.5,135C185.981,135,140,180.981,140,237.5S185.981,340,242.5,340S345,294.019,345,237.5S299.019,135,242.5,135z    M242.5,310c-39.977,0-72.5-32.523-72.5-72.5s32.523-72.5,72.5-72.5s72.5,32.523,72.5,72.5S282.477,310,242.5,310z" />
    </g>
  </svg>
);

export default SettingIcon;
